import { render } from "./SortableColumn.vue?vue&type=template&id=1f4a5e1b"
import script from "./SortableColumn.vue?vue&type=script&lang=js"
export * from "./SortableColumn.vue?vue&type=script&lang=js"

import "./SortableColumn.vue?vue&type=style&index=0&id=1f4a5e1b&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.5.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__